import * as React from 'react';
import { useContext } from 'react';
import { Redirect } from 'react-router-dom';
import SearchView from 'containers/search';
import { pwrDistroReviewFieldsets } from 'containers/search/SearchForm';
import { ClientContext } from 'containers/client/ClientProvider';
import { getIsPwrDistroClient } from 'components/ModerationCard/ClientModerationCard/utils';

export function ReviewSearch(props) {
  const clientProps = useContext(ClientContext);

  if (clientProps && !getIsPwrDistroClient(clientProps.clientId, clientProps)) {
    const { location } = props;
    const params = new URLSearchParams(location.search);
    const isNative = params.get('native');
    const path = isNative === 'false' ? '/network-reviews' : '/native-reviews';
    const newPathname = location.pathname.replace('/reviews-search', path);

    return <Redirect to={{ pathname: newPathname, search: location.search }} />;
  }

  return (
    <SearchView
      label="Reviews"
      primaryFieldsets={pwrDistroReviewFieldsets.primaryFieldsets}
      extraFieldsets={pwrDistroReviewFieldsets.extraFieldsets}
      {...props}
    />
  );
}



// WEBPACK FOOTER //
// ./src/containers/search/PwrDistribution/ReviewSearch.js